export const generateRandomPassword = (length = 12): string => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789*"
  const array = new Uint32Array(length)
  window.crypto.getRandomValues(array)
  return Array.from(array)
    .map((x) => charset[x % charset.length])
    .join("")
}
